import React from 'react';
import styled from 'styled-components';

import about from '../../tools/about';

const AboutJumbotron = styled.div`
  display: flex;
  flex-direction: column;
`;
const AboutDescription = styled.p`
  margin-left: 1rem;
  color: #7b1fa2;
`;
const SectionHeading = styled.h1`
  font-size: 24px;
  margin-left: 1rem;
  color: #ed5a5c;
`;
const SectionPara = styled.p`
  margin-left: 1rem;
`;
const SectionBubblesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
  border-collapse: separate;
  border-spacing: 2rem 0;
  margin: 2rem 1rem;
`;
const SectionBubbles = styled.div`
  margin: 0.25rem;
  padding: 0.5rem;
  color: #fff;
  background-color: #0c7489;
  border-radius: 4px;
`;
const ArticleLink = styled.a`
  color: #7b1fa2;
  text-decoration: underline;
`;
const About = props => {
  return (
    <div>
      <AboutJumbotron>
        <SectionHeading>About</SectionHeading>
        <AboutDescription>{about.description}</AboutDescription>
      </AboutJumbotron>
      <section>
        <SectionHeading>Technologies</SectionHeading>
        <SectionPara>
          These are the technologies that I have worked:
        </SectionPara>
        <SectionBubblesList>
          {about.proficiencies.map((data, index) => {
            return <SectionBubbles key={index}>{data}</SectionBubbles>;
          })}
        </SectionBubblesList>
      </section>
      <section>
        <SectionHeading>Articles</SectionHeading>
        <SectionPara>
          You can checkout some of the articles/tutorials written by me:
          {'  '}
          <ArticleLink
            href="https://medium.com/@iamgrawal"
            rel="noopener noreferrer"
            target="_blank"
          >
            Medium
          </ArticleLink>
          {',  '}
          <ArticleLink
            href="https://gitall.tech/project/midi-mixer/"
            rel="noopener noreferrer"
            target="_blank"
          >
            GitAll
          </ArticleLink>
        </SectionPara>
      </section>
    </div>
  );
};

export default About;
